// src/components/Invoices.tsx
import { observer } from "mobx-react";
import React from "react";
import {
  Text,
  Box,
  Stack,
  Divider,
  Title,
  Loader,
  Button,
} from "@mantine/core";

import { BobsWorkspace } from "../stores/BobsWorkspace";
import { IconDownload } from "@tabler/icons-react";

const toCSV = (data: any[][]): string => {
  return data
    .map((row) =>
      row
        .map((cell) => {
          if (cell === null || cell === undefined) return '""';
          const escaped = cell.toString().replace(/"/g, '""');
          return `"${escaped}"`;
        })
        .join(",")
    )
    .join("\n");
};

const Spreadsheet = observer(
  ({ bobsWorkspace }: { bobsWorkspace: BobsWorkspace }) => {
    const selectedBob = bobsWorkspace.selectedBob;
    // console.log("spreadsheet lines", selectedBob.spreadsheetLines);

    const handleDownload = () => {
      const csvContent = toCSV(selectedBob.spreadsheetLines);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "rizful-vault-transactions.csv";
      link.click();
      URL.revokeObjectURL(url);
    };

    return (
      <>
        <Title order={2}>Transactions</Title>
        <Button
          leftSection={<IconDownload />}
          size={"sm"}
          onClick={handleDownload}
        >
          Download Spreadsheet
        </Button>
      </>
    );
  }
);

export default Spreadsheet;
